import mixpanel from 'mixpanel-browser';
import { track as trackInCrm } from './flito';

mixpanel.init('40b654257026f8fc3a116f6ba15e6400', {
  // debug: true,
  persistence: 'localStorage'
});

// One id per event, sent to both, so the CRM's Mixpanel import can skip
// the events it already got straight from the site.
const newEventId = () =>
  window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

// Wrapper around mixpanel.track. FlitoCRM gets each event too, except page
// loads: its own tracker records those.
const track = (name, props) => {
  const withId = { ...props, flito_event_id: newEventId() };
  mixpanel.track(name, withId);
  if (!/^loaded a page$/i.test(name)) trackInCrm(name, withId);
};

// Wrapper around mixpanel.identify
const identify = (id) => {
  mixpanel.identify(id);
};

// Wrapper around mixpanel.people.set
const setPeople = (props) => {
  mixpanel.people.set(props);
};

export { track, identify, setPeople };
